import {
    IHistoricActivity,
    IHistoricalConversation,
    IInternalHistoricalWorkItem,
} from '@dxp/core/models';

export const mapConversationToActivity = (
    conversation: IHistoricalConversation,
): IHistoricActivity => {
    const workItem = conversation.workItems?.at(-1);
    const queueSegment = conversation.queueSegments?.at(-1);
    const rejectedEnqueueAttempt = conversation.rejectedEnqueueAttempts?.at(-1);

    return {
        id: conversation.id,
        agent: workItem?.agent,
        queue: workItem?.queue,
        workItemId: workItem?.id ?? '',
        channelType: conversation.channelType,
        date: new Date(conversation.startedAtUtc),
        duration: conversation.durationInSeconds,
        tag: workItem?.completionCode ?? '',
        channelId: conversation.channelId,
        channelName: conversation.channel?.name ?? '',
        notes: workItem?.notes ?? '',
        notesFromAISummary: workItem?.notesFromAISummary ?? false,
        customerName:
            `${conversation.customerFirstName ?? ''} ${conversation.customerMiddleName ?? ''} ${conversation.customerLastName ?? ''}`.trim(),
        result:
            workItem?.result ??
            queueSegment?.dequeuedReason ??
            rejectedEnqueueAttempt?.rejectReason ??
            conversation.conversationEndedReason,
        isOutbound: conversation.isOutbound,
        isMonitoringWorkItem: workItem?.isMonitoringWorkItem ?? false,
    };
};

export const mapWorkitemToActivity = (
    workItem: IInternalHistoricalWorkItem,
): IHistoricActivity => {
    const conversation = workItem.conversations?.at(-1);

    return {
        id: workItem.primaryConversationId ?? '',
        agent: workItem.agent,
        queue: workItem.queue,
        workItemId: workItem.id,
        channelType: workItem?.channel?.channelType ?? 'virtual',
        date: new Date(workItem.startTimeUtc),
        duration: workItem.durationInSeconds,
        tag: workItem?.completionCode ?? '',
        channelId: workItem.primaryChannelId ?? 0,
        channelName: workItem.channel?.name ?? '',
        notes: workItem?.notes ?? '',
        notesFromAISummary: workItem?.notesFromAISummary ?? false,
        customerName:
            `${conversation?.customerFirstName ?? ''} ${conversation?.customerMiddleName ?? ''} ${conversation?.customerLastName ?? ''}`.trim(),
        result: workItem?.result ?? conversation?.conversationEndedReason,
        isOutbound: conversation?.isOutbound ?? false,
        isMonitoringWorkItem: workItem?.isMonitoringWorkItem ?? false,
    };
};
